import {
  Modal,
  ModalFooter,
  ModalFooterSpinner,
  ModalInput,
  ModalButton,
  ModalBody,
  modalConnect,
} from "@modal";

import { ceModalUpdateState } from "@js/actions/studio/modals.js";

import {
  ceModalUploadFromUrlReopen,
  ceModalUploadFromUrlSave,
  ceModalUploadFromUrlCancel,
} from "@js/actions/studio/campaign_content_section/modal_upload_from_url.js";

const ModalTitle = () => t("phrases.react_content.import_modal.title");

const ModalUploadFromUrl = modalConnect((props) => {
  switch (props.step) {
    case "enter_url":
      return <ModalUploadFromUrlEnterUrl />;
    case "downloading":
      return <ModalUploadFromUrlDownloading />;
    case "download_error":
      return <ModalUploadFromUrlDownloadError />;
  }
});

const ModalUploadFromUrlEnterUrl = modalConnect((props) => (
  <Modal
    title={ModalTitle()}
    onCancel={() => props.dispatch(ceModalUploadFromUrlCancel())}
  >
    <ModalInput
      type="text"
      onChange={(e) =>
        props.dispatch(ceModalUpdateState({ url: e.target.value }))
      }
      value={props.url || ""}
      error={props.validation_error}
    />

    <ModalFooter>
      <ModalButton
        onClick={() => props.dispatch(ceModalUploadFromUrlCancel())}
        text={t("buttons.cancel")}
        diminished
      />
      <ModalButton
        onClick={() => props.dispatch(ceModalUploadFromUrlSave("text"))}
        text={t("phrases.react_content.import_modal.import_text")}
      />
      <ModalButton
        onClick={() => props.dispatch(ceModalUploadFromUrlSave("html"))}
        text={t("phrases.react_content.import_modal.import_html")}
      />
    </ModalFooter>
  </Modal>
));

const ModalUploadFromUrlDownloading = modalConnect((props) => (
  <Modal
    title={ModalTitle()}
    onCancel={() => props.dispatch(ceModalUploadFromUrlCancel())}
  >
    <ModalBody>
      <ModalInput
        type="text"
        value={props.url || ""}
        error={props.validation_error}
      />
      <div>{t("phrases.react_content.downloading_url")}</div>
    </ModalBody>

    <ModalFooter>
      <ModalFooterSpinner
        style={{
          marginRight: "9px",
        }}
      />
      <ModalButton
        onClick={() => props.dispatch(ceModalUploadFromUrlCancel())}
        text={t("buttons.cancel")}
        diminished
      />
    </ModalFooter>
  </Modal>
));

const ModalUploadFromUrlDownloadError = modalConnect((props) => (
  <Modal
    title={ModalTitle()}
    onCancel={() => props.dispatch(ceModalUploadFromUrlCancel())}
    onSave={() => props.dispatch(ceModalUploadFromUrlReopen())}
    saveText={t("buttons.retry")}
  >
    <ModalBody error={props.download_error} />
  </Modal>
));

export default ModalUploadFromUrl;
